<template>
  <div id="srarchBaby">
    <div ref="searchBox" class="searchBox">
      <div class="search-backicon" @click="handleBack">
        <img alt="" src="@/assets/images/babyFeeding/search-back.png">
      </div>
      <div class="search-input">
        <van-search
            ref="search"
            v-model="searchText"
            :disabled="disabled"
            :left-icon="require('@/assets/images/babyFeeding/search.png')"
            :placeholder="placeholder"
            :readonly="readonly"
            class="vanSearch"
            maxlength="50"
            shape="round"
            @clear="clear"
            @focus="searchFocus"
            @input="searchInput"
            @search="onSearch"
        />
        <span class="canBtn" @click="onSearch">搜索</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      searchText: this.$route.query.searchText || ""
    }
  },
  watch: {
    text: {
      handler(newValue) {
        this.searchText = newValue
        console.log(newValue, 'newValue2')
      },
      deep: true
    }
  },
  props: {
    text: String,
    placeholder: {
      type: String,
      default: '简单一搜，给你食谱'
    },
    disabled: {
      type: Boolean
    },
    // 只读
    readonly: {
      type: Boolean
    },
    focus: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.focus ? this.$refs.search.querySelector('input').focus() : false;
  },
  methods: {
    handleBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.replace("/babyFeeding")
      }
    },
    onCancel() {

    },
    clear() {

    },
    searchFocus() {
      if (this.readonly) {
        this.$router.push({name: 'searchRecipes'})
        // this.$emit('searchFocus', false)
      } else {
        this.$emit('searchFocus', this.searchText)
      }
    },
    searchInput() {
      this.$emit('searchInput', this.searchText)
    },
    onSearch() {
      if (this.readonly) {
        this.$router.push({name: 'searchRecipes'})
        // this.$emit('onSearch', false)
      } else {
        this.$emit('onSearch', this.searchText)
      }
    }
  }
}
</script>

<style lang="less" scoped>
#srarchBaby {
  .searchBox {
    overflow: hidden;
    display: flex;
    align-items: center;
    padding: 12px 16px 0 0;

    .search-backicon {
      width: 10px;
      height: 18px;
      margin-right: 8px;
      margin-left: 8px;

      img {
        width: 22px;
        height: 22px;
      }
    }

    .van-search__action {
      font-size: @indexFontSize14;
    }

    .van-field__control {
      padding-left: 2px;
    }

    .search-input {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 2px 2px 2px 10px;
      border-radius: 21px;
      border: 2px solid #ff67c1;
      margin-left: 12px;

      .vanSearch {
        /deep/ .van-icon {
          font-size: 20px;

          .van-icon__image {
            width: 19px;
            height: 20px;
          }
        }
      }

      .van-search {
        flex: 1;
        padding: 0;

        .van-search__content {
          padding-left: 0;
          background: none;

          .van-cell {
            background: none;
            padding-right: 0;
          }
        }

        .van-search__action {
          font-size: @indexFontSize13;
        }

        /deep/ .van-field__control {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: #999;
        }

        /deep/ input {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }

      .canBtn {
        width: 50px;
        height: 34px;
        margin-left: 11px;
        background: linear-gradient(90deg, #ff9ed8 0%, #ff67c1 100%);
        border-radius: 17px;
        font-size: 14px;
        color: #fff;
        line-height: 34px;
        text-align: center;
      }
    }

    // @media screen and (max-width: 640px) {
    //   .van-search {
    //     width: 291px;
    //     padding: 12px 0;
    //   }
    // }
  }
}

</style>